<template>
  <div class="wrapper">
    <parallax class="page-header header-filter"> </parallax>
    <div class="main main-raised ">
      <div class="section">
        <div class="container">
          <div class="md-layout ">
            <div
              class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center container-override "
            >
              <transition-group name="fade">
                <div key="main-content" class="animated">
                  <component
                    v-bind:is="currentComponent"
                    v-bind:userID="userID"
                    v-bind:project="project"
                    v-bind:region="region"
                    v-bind:videos="videos"
                    v-bind:croppingWindow="croppingWindow"
                    v-bind:uploadParams="uploadParams"
                    v-bind:predictionParams="predictionParams"
                    v-on:updateVideos="$emit('updateVideos', $event)"
                    v-on:updateButton="showButton = $event"
                    v-on:increaseCurrentStep="$emit('increaseCurrentStep')"
                  >
                  </component>
                </div>
              </transition-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Start from "@/views/components/Start";
import UploadField from "@/views/components/UploadField";
import CroppingWindow from "@/views/components/CroppingWindow";
import PredictionViewer from "@/views/components/PredictionViewer";
import About from "@/views/components/About";

export default {
  name: "GettingStarted",
  props: [
    "userID",
    "project",
    "region",
    "videos",
    "croppingWindow",
    "uploadParams",
    "predictionParams",
    "currentStep"
  ],
  components: {
    Start,
    UploadField,
    CroppingWindow,
    PredictionViewer,
    About
  },
  data() {
    return {
      showButton: true,
      predictionSteps: [
        { content: "Start" },
        { content: "UploadField" },
        { content: "CroppingWindow" },
        { content: "PredictionViewer" },
        { content: "About" }
      ]
    };
  },
  methods: {},
  computed: {
    currentComponent() {
      return this.predictionSteps[this.currentStep].content;
    }
  },
  created() {},
  destroyed() {}
};
</script>

@import '../../assets/css/styling.css';

<style lang="scss" scoped>
.step-selection {
  padding-top: 50px;
}
.next-step {
  padding-left: 60%;
}
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}
.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.btn {
  display: inline-block;
  border: none;
  background: #555;
  color: #fff;
  padding: 5px 2px;
  cursor: pointer;
}

.card {
  transition: all 0.5s;
}
.card-enter, .card-leave-to
/* .card-leave-active for <2.1.8 */ {
  opacity: 0;
  transform: scale(0);
}
</style>
